module.exports = __webpack_public_path__ + "img/bg9.d5296454.jpg";